import * as React from "react";
import { useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import * as moment from "moment";
import pageStyles from "./BlogStyles";
import { ElementsParallax, AdsComponent } from "components";
import { useBlog } from "services";
import { PostProps } from "models";
import Model from "hooks/Model";
import { translateMonth } from "utils/validations";

function BlogScreen() {
  const styles = pageStyles();
  const navigate = useNavigate();

  const { currentPosts } = useBlog();

  const renderPosts = () =>
    currentPosts.map(({ id, image, created, title }: PostProps) => (
      <Grid item className={styles.itemPlayer} key={id}>
        <Box
          className={styles.itemImgPlayer}
          onClick={() => navigate(`/detail-post?id=${id}`)}
        >
          <img src={image} className={styles.imageVideo} alt="Video" />
          {moment().diff(moment(created, "x"), "d") < 7 ? (
            <div className={styles.newBadge}>Recien agregado</div>
          ) : (
            <></>
          )}
        </Box>
        <h3 className={styles.itemNamePlayer}>{title}</h3>
        <p className={styles.itemDescriptionPlayer}>
          {translateMonth(moment(created, "x").format("DD MMMM YYYY"))}
        </p>
      </Grid>
    ));

  useEffect(() => {
    Model.setData("layoutConfig", { withBg: true });
    Model.setData("loading", false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ElementsParallax variant="leftBg" />
      <ElementsParallax variant="rightBg" />

      <AdsComponent />

      {/* <PromoBannerComponent /> */}

      <p className={styles.label}>{"🤓"} Nuestro blog</p>
      <Grid
        container
        className={styles.containerListPlayer}
        sx={{ marginBottom: 12 }}
      >
        {renderPosts()}
      </Grid>
    </>
  );
}

export default BlogScreen;
